import { VALIDATION_STATUS } from 'config/ui';
import dialogActions from './actions';
import pageActions from '../page/actions';
import groupActions from '../groups/actions';

/** TODO: ugh this is kinda bad...All of this needs to integrated because
 * redux handles error states with groups, but when not integrated
 * it just creates more work.
 */
const DIALOGS_WITH_STATE = ['home_verify_deposits'];

const dialogReducer = (state = {}, action) => {
  switch (action.type) {
    case dialogActions.OPEN:
      if (DIALOGS_WITH_STATE.includes(action.payload.type)) {
        return {
          ...state,
          open: true,
          params: {
            ...action.payload.params,
            status: {
              errorMsg: '',
              loading: false,
              success: action.payload.params.request.fundingVerificationHasError ? false : null,
            },
          },
          type: action.payload.type,
        };
      }
      return {
        ...state,
        open: true,
        params: action.payload.params,
        type: action.payload.type,
      };
    case pageActions.VERIFY_FUNDING:
      return {
        ...state,
        params: {
          ...state.params,
          status: {
            ...state.params.status,
            loading: true,
          },
        },
      };
    case pageActions.VERIFY_FUNDING_SUCCESS:
      return {
        ...state,
        params: {
          ...state.params,
          status: { errorMsg: '', loading: false, success: true },
        },
      };
    case pageActions.VERIFY_FUNDING_FAILED: {
      const { msgs } = action.payload.data.result;
      if (msgs) {
        return {
          ...state,
          params: {
            ...state.params,
            status: {
              errorMsg: msgs['*'] || '',
              loading: false,
              success: Object.keys(msgs).length > 0 ? null : false,
            },
          },
        };
      }
      return {
        ...state,
        params: {
          ...state.params,
          status: {
            errorMsg: '',
            loading: false,
            success: false,
          },
        },
      };
    }
    case pageActions.GO_FAILED:
    case dialogActions.CLOSE:
    case pageActions.GO_SUCCESS:
    case pageActions.SAVE_SIGNATURE_SUCCESS:
    case dialogActions.AGREE_SUCCESS:
    case dialogActions.SIGN_SUCCESS:
    case pageActions.GET_CURRENT:
      return {
        ...state,
        open: false,
        params: null,
        type: null,
      };
    case groupActions.NEXT_FAILED:
    case pageActions.NEXT_FAILED: {
      const { data } = action.payload;
      const response = data.result || data.meta;
      if (response && response.msgs && response.msgs['*']) {
        if (response.msgs['*'] === VALIDATION_STATUS.SELECT_ADDRESS) {
          return {
            ...state,
            open: true,
            type: 'selectaddress',
          };
        }

        if (response.msgs['*'] === VALIDATION_STATUS.SEND_VERIFICATION) {
          return {
            ...state,
            open: true,
            type: 'verifyuser',
          };
        }

        if (
          response.msgs['*'] === VALIDATION_STATUS.MOBILE_VALIDATION_INCONCLUSIVE ||
          response.msgs['*'] === VALIDATION_STATUS.MOBILE_VALIDATION_DECLINED
        ) {
          return {
            ...state,
            open: true,
            type: 'mobilevalidation',
          };
        }
      }
      if (response?.msgs?.['*_USER_AUTH']) {
        return {
          ...state,
          open: false,
          params: null,
          type: null,
        };
      }

      return state;
    }
    case dialogActions.AGREE:
    case dialogActions.SIGN:
    case pageActions.SAVE_SIGNATURE:
      return {
        ...state,
        params: {
          ...state.params,
          errorMsg: '',
          loading: true,
        },
      };
    case pageActions.SAVE_SIGNATURE_FAILED:
      return {
        ...state,
        params: {
          ...state.params,
          errorMsg: action.payload.errorMsg,
          loading: false,
        },
      };
    case pageActions.MOBILE_VALIDATION_RESEND:
    case pageActions.MOBILE_VALIDATION_SUBMIT:
      return {
        ...state,
        params: {
          ...state.params,
          errorMsg: '',
          resendClicked: (state.params && state.params.resendClicked) || 0,
          successMsg: '',
        },
      };
    case pageActions.MOBILE_VALIDATION_SUCCESS:
      return {
        ...state,
        params: {
          ...state.params,
          resendClicked: state.params.resendClicked && state.params.resendClicked + 1,
          successMsg: action.payload.successMsg,
        },
      };
    case pageActions.MOBILE_VALIDATION_SUBMIT_FAILED:
      return {
        ...state,
        params: {
          ...state.params,
          disableResend: action.payload.disableResend,
          errorMsg: action.payload.errorMsg,
        },
      };
    case dialogActions.SEND_CODE_SUCCESS:
      return {
        ...state,
        open: true,
        type: 'mobilevalidation_userauth',
      };
    default:
      return state;
  }
};

export default dialogReducer;
